<template>
  <v-row style="align-items: center" class="menu px-0 pt-1">
    <v-col cols="12" :sm="organization_id ? 9 : 11">
      <v-text-field
        v-model="search"
        :label="$t('tables.search-label')"
        single-line
        hide-details
        clearable
        class="pa-0 ma-0"
      ></v-text-field>
    </v-col>
    <v-col cols="3" sm="1" class="reset">
      <v-btn block v-on:click="reset" :loading="loading">
        <v-icon>
          mdi-filter-remove-outline
        </v-icon>
      </v-btn>
    </v-col>
    <v-col cols="9" sm="2" v-if="organization_id">
      <v-btn
        color="primary"
        block
        v-on:click="reset"
        :loading="loading"
        :to="{
          name: 'new-project',
          params: {
            organization_id: organization_id
          }
        }"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t(`tables.create`) }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import debounce from "../../../assets/js/debounce";
export default {
  name: "Search",
  data: function() {
    let search = this.$route.query.search || "";
    return {
      search,
      loading: false
    };
  },
  props: ["organization_id"],
  methods: {
    queryForSearch() {
      let to = { ...this.$route };
      to.query = {
        ...to.query
      };
      if (this.search) {
        to.query.search = this.search;
      } else {
        delete to.query.search;
      }
      this.$router.push(to);
    },
    reset() {
      let to = { ...this.$route };
      to.query = {};
      this.$router.push(to);
      this.search = "";
    },
    startQueryForSearch: debounce(function() {
      this.queryForSearch();
    }, 500)
  },
  watch: {
    search() {
      this.startQueryForSearch();
    }
  }
};
</script>

<style scoped></style>
